// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module__title___1U6db","body":"index-module__body___f7r6I"};